import { render } from "./ProjectsListContainer.vue?vue&type=template&id=b341b23e&scoped=true"
import script from "./ProjectsListContainer.vue?vue&type=script&lang=js"
export * from "./ProjectsListContainer.vue?vue&type=script&lang=js"

import "./ProjectsListContainer.vue?vue&type=style&index=0&id=b341b23e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b341b23e"]])

export default __exports__